<ng-container *ngIf="showLastNamesAlert">
  <app-alert-message 
    [text]="'BOOKING_MODULE.PAX.ALERTS.TWO_LASTNAMES' | transloco"
    [alertType]="alertType">
  </app-alert-message>
</ng-container>
